let csrfTokenFallback: string | null = null

export function getCsrfTokenFallback(): string | null {
  return csrfTokenFallback
}

export function setCsrfTokenFallback(token: string | null): void {
  csrfTokenFallback = token
}

export function clearCsrfTokenFallback(): void {
  csrfTokenFallback = null
}
